import React, { Component } from 'react';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';
import ConfirmDialog from 'components/Dialog/Confirm';
import {fetchSessionSetting, updateSessionSetting} from 'actions/SessionActions';
import {getURL} from '../../routes';

class Session extends Component {
  state = {
    mornShift: {
      startAt: '00:00',
      endAt: '00:00',
      ableAt: '00:00',
      disableAt: '00:00',
      workUnit: '-',
    },
    aftnShift: {
      startAt: '00:00',
      endAt: '00:00',
      ableAt: '00:00',
      disableAt: '00:00',
      workUnit: '-',
    },
    OTConfig: {
      startAt: '00:00',
      endAt: '00:00',
      ableAt: '00:00',
      disableAt: '00:00',
      minPerShift: '-',
      workUnitPerShift: '-',
      minWorkTime: '00:00',
    }
  }

  componentDidMount() {
    fetchSessionSetting()
      .then((respone) => {
        this.setState(respone.data);
      })
      .catch((error) => {

      })
  }

  handleMornShiftChange = (e) => {
    let {name, value} = e.target;
    this.setState(Object.assign({}, this.state, {
      mornShift: {
        ...this.state.mornShift,
        [name]: value,
      }
    }))
  }

   handleAftnShiftChange = (e) => {
    let {name, value} = e.target;
    this.setState(Object.assign({}, this.state, {
      aftnShift: {
        ...this.state.aftnShift,
        [name]: value
      }
    }))
  }

  handleOTConfigChange = (e) => {
    let {name, value} = e.target;
    this.setState(Object.assign({}, this.state, {
      OTConfig: {
        ...this.state.OTConfig,
        [name]: value
      }
    }))
  }

  trySave = () => {
    ConfirmDialog("將儲存所以修改")
      .then(
        () => {this.handleSaveSessionConfig()},
        () => {},
      )
  }


  handleSaveSessionConfig = (e) => {
    let data = Object.assign({}, this.state);
    updateSessionSetting(data)
      .then((respone) => {

      })
      .catch((error) => {
        alert("fail")
      })
  }

  render() {
    let {mornShift, aftnShift, OTConfig} = this.state;
    let {dispatch} = this.props;

    return (
      <div className="Session setting-panel">
        <div className="setting-header">
          <button
            className="btn btn-default"
            onClick={()=>{dispatch(push(getURL('ws-admin/setting')))}}>
            返回
          </button>
          <button className="btn btn-primary pull-right" onClick={this.trySave}>
            儲存
          </button>
        </div>
        <div className="panel panel-ws">
          <div className="panel-heading">
            上午時段
          </div>
          <div className="panel-body">
            <form className="form-horizontal">
              <div className="form-group">
                <label className="col-xs-2 control-label">時間</label>
                <div className="col-xs-5">
                  <input
                    type="time"
                    className="form-control"
                    name="startAt"
                    value={mornShift.startAt}
                    onChange={this.handleMornShiftChange} />
                </div>
                <div className="col-xs-5">
                  <input
                    type="time"
                    className="form-control"
                    name="endAt"
                    value={mornShift.endAt}
                    onChange={this.handleMornShiftChange} />
                </div>
              </div>

              <div className="form-group">
                <label className="col-xs-2 control-label">可簽到時間</label>
               <div className="col-xs-5">
                 <input
                    type="time"
                    className="form-control"
                    name="ableAt"
                    value={mornShift.ableAt}
                    onChange={this.handleMornShiftChange} />
                </div>
                <div className="col-xs-5">
                  <input
                    type="time"
                    className="form-control"
                    name="disableAt"
                    value={mornShift.disableAt}
                    onChange={this.handleMornShiftChange} />
                </div>
              </div>

              <div className="form-group">
                <label className="col-xs-2 control-label">工數</label>
                <div className="col-xs-10">
                  <input
                    type="text"
                    className="form-control"
                    name="workUnit"
                    value={mornShift.workUnit}
                    onChange={this.handleMornShiftChange} />
                </div>
              </div>
            </form>
          </div>
        </div>

        <div className="panel panel-ws">
          <div className="panel-heading">
            下午時段
          </div>
          <div className="panel-body">
            <form className="form-horizontal">
              <div className="form-group">
                <label className="col-xs-2 control-label">時間</label>
                <div className="col-xs-5">
                  <input
                    type="time"
                    className="form-control"
                    name="startAt"
                    value={aftnShift.startAt}
                    onChange={this.handleAftnShiftChange} />
                </div>
                <div className="col-xs-5">
                  <input
                    type="time"
                    className="form-control"
                    name="endAt"
                    value={aftnShift.endAt}
                    onChange={this.handleAftnShiftChange} />
                </div>
              </div>

              <div className="form-group">
                <label className="col-xs-2 control-label">可簽到時間</label>
               <div className="col-xs-5">
                 <input
                    type="time"
                    className="form-control"
                    name="ableAt"
                    value={aftnShift.ableAt}
                    onChange={this.handleAftnShiftChange} />
                </div>
                <div className="col-xs-5">
                  <input
                    type="time"
                    className="form-control"
                    name="disableAt"
                    value={aftnShift.disableAt}
                    onChange={this.handleAftnShiftChange} />
                </div>
              </div>

              <div className="form-group">
                <label className="col-xs-2 control-label">工數</label>
                <div className="col-xs-10">
                  <input
                    type="text"
                    className="form-control"
                    name="workUnit"
                    value={aftnShift.workUnit}
                    onChange={this.handleAftnShiftChange} />
                </div>
              </div>
            </form>
          </div>
        </div>

        <div className="panel panel-ws">
          <div className="panel-heading">
            加班時段
          </div>
          <div className="panel-body">
            <form className="form-horizontal">
              <div className="form-group">
                <label className="col-xs-2 control-label">時間</label>
                <div className="col-xs-5">
                  <input
                    type="time"
                    className="form-control"
                    name="startAt"
                    value={OTConfig.startAt}
                    onChange={this.handleOTConfigChange} />
                </div>
                <div className="col-xs-5">
                  <input
                    type="time"
                    className="form-control"
                    name="endAt"
                    value={OTConfig.endAt}
                    onChange={this.handleOTConfigChange} />
                </div>
              </div>
              <div className="form-group">
                <label className="col-xs-2 control-label">可簽到時間</label>
               <div className="col-xs-5">
                 <input
                    type="time"
                    className="form-control"
                    name="ableAt"
                    value={OTConfig.ableAt}
                    onChange={this.handleOTConfigChange} />
                </div>
                <div className="col-xs-5">
                  <input
                    type="time"
                    className="form-control"
                    name="disableAt"
                    value={OTConfig.disableAt}
                    onChange={this.handleOTConfigChange} />
                </div>
              </div>
              <div className="form-group">
                <label className="col-xs-2 control-label">工數/分鐘</label>
                <div className="col-xs-5">
                  <input
                    type="text"
                    className="form-control"
                    name="workUnitPerShift"
                    value={OTConfig.workUnitPerShift}
                    onChange={this.handleOTConfigChange} />
                </div>
                <div className="col-xs-5">
                  <input
                    type="number"
                    className="form-control"
                    name="minPerShift"
                    value={OTConfig.minPerShift}
                    onChange={this.handleOTConfigChange} />
                </div>
              </div>

              <div className="form-group">
                <label className="col-xs-2 control-label">最少工作分鐘</label>
                <div className="col-xs-10">
                  <input
                    type="number"
                    className="form-control"
                    name="minWorkTime"
                    value={OTConfig.minWorkTime}
                    onChange={this.handleOTConfigChange} />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    )
  }
}

export default connect((state) => ({
}))(Session);



// WEBPACK FOOTER //
// ./src/components/Setting/SessionPanel.js